// PlanoCard.tsx
import React from 'react';
import type { Plano } from './planoTypes';
import {
    formatPlanPrice,
    formatServiceRecurrence,
    getPlanBillingLabel,
    getPlanCoverUrl,
    getPlanPriceSuffix,
} from './planosUtils';
import { Check, Layers } from 'lucide-react';

interface PlanoCardProps {
    plano: Plano;
    onContratar?: (plano: Plano) => void;
}

const PlanoCard: React.FC<PlanoCardProps> = ({ plano, onContratar }) => {
    const coverUrl = getPlanCoverUrl(plano);
    const services = Array.isArray(plano.services) ? plano.services : [];

    return (
        <li className="pla-offer">
            <span className="pla-thumb">
                {coverUrl ? (
                    <img src={coverUrl} alt="" loading="lazy" />
                ) : (
                    <Layers aria-hidden />
                )}
            </span>

            <div className="pla-offer-body">
                <h2 className="pla-row-title">{plano.name}</h2>

                {plano.description && <p className="pla-card-description">{plano.description}</p>}

                {services.length > 0 && (
                    <ul className="pla-services">
                        {services.map((s) => (
                            <li key={s._id}>
                                <Check aria-hidden />
                                <span>
                                    {Number(s.quantity || 1)}x {s.serviceName || s.service?.name || 'Serviço'}{' '}
                                    {formatServiceRecurrence(s.recurrence)}
                                </span>
                            </li>
                        ))}
                    </ul>
                )}
            </div>

            <div className="pla-offer-side">
                <div>
                    <p className="pla-row-price">
                        {formatPlanPrice(plano.price)}
                        <span>{getPlanPriceSuffix(plano.periodicity)}</span>
                    </p>
                    <p className="pla-billing">{getPlanBillingLabel(plano)}</p>
                </div>
                {onContratar && (
                    <button type="button" onClick={() => onContratar(plano)} className="btn btn-primary btn-sm shrink-0">
                        Contratar
                    </button>
                )}
            </div>
        </li>
    );
};

export default PlanoCard;
